export const hideUI = $video => {
  const $videoContainer = $video.closest('.js-video');
  $videoContainer.classList.add('has-hiddenUI');
  clearTimeout($videoContainer.hideUITimeout);
};
